<div
    class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-w-100pct cmps-cdk-h-100pct cmps-report-bg-color-ukn-103"
>
    <div
        class="cmps-cdk-bg-color-white cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-h-55px cmps-cdk-min-h-55p cmps-cdk-z-index-2"
    >
        <div
            class="cmps-cdk-d-flex cmps-cdk-flex-80 cmps-cdk-p-0dot5 cmps-cdk-cg-0dot5"
        >
            <div
                class="cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-d-flex cmps-cdk-flex-grow-1"
            >
                <div
                    class="cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-p-0dot25"
                >
                    <cmps-icon
                        class="cmps-cdk-color-white nested:cmps-cdk-w-inherit nested:cmps-cdk-h-inherit cmps-cdk-w-28px cmps-cdk-h-28px"
                        svgIcon="compass-outline"
                    ></cmps-icon>
                </div>
                <div class="cmps-cdk-font-bold cmps-cdk-font-size-18p">
                    Report Builder
                </div>
                <div class="cmps-cdk-pl-2">
                    <a
                        class="cmps-cdk-align-items-center cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-blue-100 cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1 hover:cmps-cdk-text-decoration-none"
                        [routerLink]="['/', 'report', 'builder']"
                        [queryParams]="_state.builderQueryParams"
                    >
                        <cmps-icon svgIcon="chevron-left"></cmps-icon>
                        <span class="cmps-cdk-line-clamp-1">Edit Report</span>
                    </a>
                </div>
                <div class="cmps-cdk-color-grey-400">
                    Generated
                    {{
                        _state.run?.results?.[0]?.timestamp == null
                            ? 'N/A'
                            : (_state.run?.results?.[0]?.timestamp
                              | cmpsDate: 'LLL-d-yyyy, h:mm:ss a')
                    }}
                </div>
            </div>
            <div
                class="cmps-cdk-align-items-center cmps-cdk-d-flex cmps-cdk-cg-0dot75"
            >
                <div>
                    <button
                        type="button"
                        class="cmps-cdk-align-items-center cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-blue-100 not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1 disabled:cmps-cdk-opacity-0dot5"
                        [disabled]="!_state.hasCsvArtifact"
                        (click)="_onDownloadCsvClick()"
                    >
                        <cmps-icon svgIcon="download"></cmps-icon>
                        <span class="cmps-cdk-line-clamp-1">Export CSV</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div
        class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
    ></div>

    <div
        class="cmps-cdk-bg-color-white cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-uik-box-shadow-200 cmps-cdk-z-index-1"
    >
        <div class="cmps-cdk-d-flex cmps-cdk-flex-80 cmps-cdk-px-0dot5">
            <cmps-report-builder-selection-bar
                [noSelect]="true"
                [viewParamLabels]="_state.viewParamLabels"
            ></cmps-report-builder-selection-bar>
        </div>
    </div>

    <div
        class="cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-flex-grow-1"
    >
        <div class="cmps-cdk-flex-80 cmps-cdk-px-0dot5 cmps-cdk-py-1">
            <div class="cmps-cdk-pos-relative cmps-cdk-h-100pct">
                <div
                    class="cmps-cdk-pos-absolute cmps-cdk-pos-bottom-0 cmps-cdk-pos-left-0 cmps-cdk-pos-right-0 cmps-cdk-pos-top-0"
                >
                    <div
                        class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-h-100p"
                    >
                        <div class="cmps-cdk-h-30px"></div>
                        <div
                            class="cmps-cdk-flex-grow-1 cmps-cdk-flex-shrink-1 cmps-cdk-flex-basis-0"
                            #measureRef
                        ></div>
                    </div>
                </div>

                <div class="cmps-cdk-d-flex">
                    <div class="cmps-uik-box-shadow-200">
                        <div
                            class="cmps-cdk-border-tl-radius-4p cmps-cdk-border-tr-radius-4p cmps-report-bg-color-ukn-105 cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-report-border-color-ukn-104 cmps-cdk-h-30px"
                        >
                            <div
                                class="cmps-cdk-font-bold cmps-cdk-px-0dot5 cmps-cdk-py-0dot25 cmps-report-color-ukn-106"
                            >
                                {{ _state.rows?.length }} rows
                            </div>
                        </div>

                        <div
                            class="cmps-cdk-bg-color-white cmps-cdk-border-bl-radius-4p cmps-cdk-border-br-radius-4p cmps-cdk-overflow-x-auto cmps-cdk-pos-relative"
                        >
                            <cmps-uikit-virtual-scroll
                                [templateRef]="viewTpl"
                                [itemWidth]="_state.rows?.[0]?.width"
                                [itemHeight]="25"
                                [items]="_state.rows"
                                [measureRef]="measureRef"
                            ></cmps-uikit-virtual-scroll>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template
    let-items="items"
    #viewTpl
>
    <div>
        <div
            class="{{ r.classList }}"
            *ngFor="let r of items"
        >
            <div
                class="{{ c.classList }}"
                [style.width.px]="c.width"
                [style.height.px]="c.height"
                [style.min-width.px]="c.width"
                [style.min-height.px]="c.height"
                *ngFor="let c of r.cells"
            >
                <div
                    class="cmps-cdk-line-clamp-1"
                    *ngIf="c.valueType == 'text' || c.valueType == null"
                >
                    {{ c.value }}
                </div>
                <div
                    class="cmps-cdk-line-clamp-1"
                    *ngIf="c.valueType === 'double precision'"
                >
                    {{
                        c.valueAsNumber == null
                            ? '-'
                            : (c.valueAsNumber | cmpsSdpNumber)
                    }}
                </div>
            </div>
        </div>
    </div>
</ng-template>
